import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { match } from 'ts-pattern';
import { z } from 'zod';
import { FillScreen, HStack, Spacer, VStack } from '@/components/Layout';
import { MediumCategoryCard } from '@/features/operation-package-instance-profile-data/-components/MediumCategoryCard';
import { ProfileAttributeValueProvider } from '@/features/operation-package-instance-profile-data/-components/ProfileAttributeValueProvider';
import { SideNavigation } from '@/features/operation-package-instance-profile-data/-components/SideNavigation';
import { EquipmentInventoryLabelCreationOperationData } from '@/routes/_staff/ga-operation-core/_packages/-components/EquipmentInventoryLabelCreationOperationData';
import { useQueryOperationPackageInstanceData } from '../-queries/useQueryOperationPackageInstanceData';
import { useSuspenseQueryOperationPackageInstance } from '../-queries/useSuspenseQueryOperationPackageInstance';
const searchSchema = z.object({
  operationTaskInstanceId: z.string().transform(value => value || undefined).optional()
});
export const Route = createFileRoute('/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/')({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema)
});
function RouteComponent() {
  const {
    id: operationPackageId,
    patternId,
    instanceId
  } = Route.useParams();
  const {
    data: instanceData
  } = useSuspenseQueryOperationPackageInstance(instanceId);
  const {
    data
  } = useQueryOperationPackageInstanceData(instanceId);
  return match(instanceData.packageType).with('EquipmentInventoryLabelCreation', () => <EquipmentInventoryLabelCreationOperationData instanceId={instanceId} operationPackageId={operationPackageId} patternId={patternId} searchParams={{
    freeText: ''
  }} onSearch={() => {
    // TODO: 検索機能を実装
  }} />).otherwise(() => {
    if (!data) return null;
    return <ProfileAttributeValueProvider data={data}>
          <FillScreen>
            <HStack className="px-12 py-6 gap-9">
              <SideNavigation data={data} />
              <VStack className="gap-12 flex-1">
                {/* すべての大分類と中分類を表示 */}
                {data.map(largeCategory => <VStack key={largeCategory.largeCategoryCode} className="gap-8 w-full" id={largeCategory.largeCategoryCode}>
                    {/* 中分類カード */}
                    {largeCategory.mediumCategoryData.map(mediumCategory => <MediumCategoryCard key={mediumCategory.mediumCategoryCode} data={mediumCategory} />)}
                  </VStack>)}
                <Spacer size={24} />
              </VStack>
            </HStack>
          </FillScreen>
        </ProfileAttributeValueProvider>;
  });
}